import styled from "styled-components";

export const Bar = styled.div`
    flex: 0 0 auto;
    border-top: 1px solid #EEF1F6;
    padding: 10px 14px;
    background: #FFFFFF;
`;

export const Row = styled.form`
    display: flex;
    align-items: center;
    gap: 10px;
    background: #F1F4F9;
    border-radius: 22px;
    padding: 6px 8px 6px 16px;
`;

export const Input = styled.input`
    flex: 1;
    border: none;
    background: transparent;
    outline: none;
    font-family: Mulish;
    font-size: 0.88rem;
    color: #2B3240;

    &::placeholder { color: #9AA4B2; }
    &:disabled { opacity: 0.6; }
`;

export const SendButton = styled.button`
    flex: 0 0 auto;
    width: 36px;
    height: 36px;
    border: none;
    border-radius: 50%;
    background: #2F80ED;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 1rem;

    &:disabled { opacity: 0.5; cursor: not-allowed; }
`;

export const ErrorText = styled.div`
    color: #EF4444;
    font-size: 0.72rem;
    margin: 4px 0 0 16px;
`;

export const AttachBtn = styled.button`
    border: none; background: transparent; color: #5B6472; cursor: pointer;
    display: inline-flex; align-items: center; font-size: 1.3rem; padding: 4px;
    &:hover { color: #0080FC; }
    &:disabled { opacity: 0.4; cursor: default; }
`;

export const Preview = styled.div`
    display: flex; align-items: center; gap: 8px; margin-bottom: 8px;
    background: #EEF4FF; border: 1px solid #DCE6F7; border-radius: 10px; padding: 8px 12px;
    max-width: 320px;
`;

export const PreviewName = styled.span`
    font-size: 0.85rem; color: #2B3240; font-weight: 600; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
`;

export const PreviewRemove = styled.button`
    border: none; background: transparent; color: #8A94A6; cursor: pointer; display: inline-flex; font-size: 1.1rem; margin-left: auto;
    &:hover { color: #EF4444; }
`;
